<template>
      <b-modal id="modal-timeout" ref="modal-timeout" :hide-footer="true" modal-class="modal-primary" centered
          title="Session expirée">
          <b-card-text class="py-1">
              Cette page est inactive depuis <strong>{{ $timeoutSession }} minutes</strong>.<br>
              Vous serez redirigé vers la page d'authentification dans 
              <strong v-if="time == 60000">1 min.</strong>
              <strong v-else>{{ time / 1000 }} sec.</strong>
          </b-card-text>
      </b-modal>
</template>

<script>
import { initialAbility } from '@/libs/acl/config'
import { BButton, BModal, VBModal, BCardText } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isUserLoggedIn } from '@/auth/utils'
export default {
  components: {
    BButton,
    BModal,
    BCardText
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      time: 1000 * 60
    };
  },
  methods: {
    logout() {
      this.$http
          .post('auth/logout',{'userPages': localStorage.getItem('userPages')})
          .then(response => {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('userData')
            localStorage.clear()
            this.$ability.update(initialAbility)
            this.$router.push({ name: 'auth-login' })
          })
          .catch((err) => {
            console.log(err)
          })
    },
    showModal() {
        this.$refs['modal-timeout'].show();
    },
  },
  mounted() {
    if(isUserLoggedIn()) {
       this.showModal()
    }
 
  },
  created() {
    if(isUserLoggedIn()) {
      let regularWorker = new Worker("/workers/timer.worker.js");
      regularWorker.onmessage = (event) => {
          this.time = event.data
          if (!this.$store.state.idleVue.isIdle) {
            regularWorker.terminate()
            regularWorker = undefined
          }

          if (this.time < 1) {
            this.logout()
            regularWorker.terminate()
            regularWorker = undefined
            this.$refs['modal-timeout'].hide()
          }
      };

      regularWorker.postMessage(this.time);
    }
  },
};
</script>